import axios from 'axios';

export const getContactActionOptions = async () => {
    const { data } = await axios.get('/app/taskFunnel/contactactionOptions');

    return data;
};

export const getTaskOutcomeOptions = async () => {
    const { data } = await axios.get('/app/taskFunnel/taskOutcomeOptions');

    return data;
};

export const getGroupMembers = async () => {
    const { data } = await axios.get('/app/taskFunnel/groupMembers');

    return data;
};

const fromObjectToArray = (object) => {
    return Object.entries(object).map(([value, label]) => ({
        value,
        label,
    }));
};

const convertValuesIntoIntegers = (data) => {
    return data.map((option) => {
        return {
            value: parseInt(option.value, 10),
            label: option.label,
        };
    });
};

const sortByValue = (data) => {
    return data.sort((a, b) => a.value - b.value);
};

export const getReminderOptions = async () => {
    const { data } = await axios.get('/app/taskFunnel/reminderOptions');

    return sortByValue(convertValuesIntoIntegers(data));
};

export const getPriorityOptions = async () => {
    const { data } = await axios.get('/app/taskFunnel/priorityOptions');

    return sortByValue(convertValuesIntoIntegers(data));
};

export const getOutcomesByIds = async (taskOutcomeIdList) => {
    const { data } = await axios.get(`/app/taskFunnel/getTaskOutcomes/${taskOutcomeIdList}`);

    return fromObjectToArray(data);
};

export const getMergeFieldsForCB = async (funnelId) => {
    let options = [];

    try {
        const params = new URLSearchParams({ funnelId: `${funnelId}` });
        const { data } = await axios.get(`/app/merge/fields/legacy?${params.toString()}`);

        options = data.categories;
    } catch (e) {
        throw new Error('There was an error loading the available merge fields. Please try again.');
    }

    return options;
};
